<template>
  <div class="phone-body">
    <div class="phone-header">
      <div class="phone-header-line1">
        <div class="phone-header-line1-hour ml-2">{{ hours }}</div>
        <div class="phone-header-line1-space"></div>
        <div class="phone-header-line1-indicators">
          <i class="phone-header-line1-indicators-icons fas fa-signal"></i>
          <i class="phone-header-line1-indicators-icons fas fa-wifi"></i>
          <i style="font-size: 20px" class="phone-header-line1-indicators-icons fas fa-battery-full"></i>
        </div>
      </div>
      <div class="phone-header-line2">
        <div class="phone-header-line2-back">
          <i class="fal fa-angle-left"></i>
        </div>
        <div class="phone-header-line2-center">
          <i class="fas fa-user-circle"></i>
          <span>{{ senderName }}</span>
        </div>
        <div class="phone-header-line2-back"></div>
      </div>
    </div>

    <div class="phone-content">
      <div class="phone-content-message-area" v-for="(message, index) in processedMessages" :key="index">
        <div class="phone-content-message-body">
          {{ message }}
        </div>
      </div>
    </div>

    <div class="phone-controls-message">
      <div class="phone-controls-message-photo">
        <i class="fas fa-camera"></i>
      </div>
      <div class="phone-controls-message-apple-store">
        <i class="fab fa-app-store"></i>
      </div>
      <div class="phone-controls-message-text">
        <div class="phone-controls-message-text-content">
          <div class="phone-controls-message-text-content-message"></div>
          <div class="phone-controls-message-text-content-send">
            <i style="font-size: 37px" class="fas fa-arrow-circle-up"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="phone-footer">
      <div class="phone-footer-apps-list">
        <div class="phone-footer-apps-list-app"></div>
        <div class="phone-footer-apps-list-app"></div>
        <div class="phone-footer-apps-list-app"></div>
        <div class="phone-footer-apps-list-app"></div>
        <div class="phone-footer-apps-list-app"></div>
        <div class="phone-footer-apps-list-app"></div>
      </div>

      <div class="phone-footer-bottom">
        <div class="phone-footer-bottom-space"></div>
        <div class="phone-footer-bottom-control"></div>
        <div class="phone-footer-bottom-space"></div>
      </div>
    </div>
  </div>
</template>

<script>
function brokeMessage(text, maxSize, start, array) {
  if (array == null || array == undefined || array == NaN) array = []
  if (start == null || start == undefined || start == NaN) start = 0
  if (!text || !maxSize) {
    throw Error('Invalid arguments')
  }

  if (text.length > maxSize) {
    let aux = text.substr(start, maxSize)
    let end = start + maxSize
    array.push(aux)
    brokeMessage(text.substr(end, Number.MAX_SAFE_INTEGER), maxSize, 0, array)
  } else {
    array.push(text)
  }
  return array
}

export default {
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
    hours: {
      type: String,
      default: () => '',
    },
    senderName: {
      type: String,
      default: () => '',
    },
  },
  computed: {
    processedMessages: function () {
      let result = this.messages.reduce((acumulador, elemento) => {
        if (elemento.length > 160) {
          acumulador.push(...brokeMessage(elemento, 1600))
        } else {
          acumulador.push(elemento)
        }
        return acumulador
      }, [])
      return result
    },
  },
}
</script>

<style lang="scss">
$default-radius: 50px;
// $default-background: $gray-500;
$default-background: #e5e5ea;
// $default-background: black;
$phone-ballon-color: #e9e9eb;

.phone-body {
  width: 530px;
  height: 900px;
  margin: auto;
  padding: 10px 10px 11px;
  // box-shadow: -5px 10.1px 120px 0 rgba(34, 37, 43, 0.18);
  background-color: $default-background;
  border-radius: $default-radius;
}

.phone-header {
  height: 152.2px;
  background-color: #f5f4f4;
  padding: 0px 0px 16px 0;
  border-top-left-radius: $default-radius;
  border-top-right-radius: $default-radius;
}

.phone-header-line1 {
  display: flex;
  border-radius: $default-radius;
}

.phone-header-line1-hour {
  flex: 2;
  text-align: center;
  padding: 13px 15px 0px 10px;
  color: black;
  font-size: 14px;
  font-weight: 800;
}

.phone-header-line1-space {
  flex: 8;
  background-color: $default-background;
  // background-color: #e5e5ea;
  border-bottom-left-radius: 35px;
  border-bottom-right-radius: 35px;
}

.phone-header-line1-indicators {
  flex: 2;
  padding: 15px 20px 0px 10px;
  color: black;
  font-size: 15px;
  font-weight: 800;
  display: flex;
}

.phone-header-line1-indicators-icons {
  flex: auto;
}

.phone-header-line2 {
  display: flex;
  padding: 10px;
}

.phone-header-line2-back {
  flex: 1;
  font-size: 55px;
  color: #2f73f6;
  font-weight: 100;
  padding-top: 10px;
}

.phone-header-line2-center {
  flex: 10;
  font-size: 60px;
  text-align: center;
  margin: auto;
  color: #a1a8b3;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.phone-header-line2-center span {
  font-size: 25px;
  color: #665;
}

.phone-content {
  height: 570px;
  background-color: #ffffff;
  margin-top: 2px;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 30px 10px;
}

.phone-content::-webkit-scrollbar-thumb {
  background-color: $primary;
}

.phone-content::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: lightgray;
}

.phone-content::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}

.phone-content-message-area {
  position: relative;
  z-index: 1;
}

.phone-content-message-body {
  min-width: 80px;
  max-width: 370px;
  min-height: 100px;
  background-color: $phone-ballon-color;
  border-radius: 25px;
  margin: 10px 10px;
  padding: 17px;
  text-align: left;
  color: $gray-base;
  font-weight: 500;
  font-size: 18px;
}

.phone-content-message-area::before {
  content: '';
  position: absolute;
  background-color: $phone-ballon-color;
  bottom: 0;
  height: 30px;
  display: block;
  z-index: -1;
  border-right: 10px solid $phone-ballon-color;
  border-bottom-right-radius: 40px 20px;
  transform: translate(0, -2px);
}

.phone-content-message-area::before {
  content: '';
  position: absolute;
  background-color: #ffffff;
  bottom: 0;
  width: 40px;
  height: 30px;
  display: block;
  z-index: -1;
  border-right: 30px solid $phone-ballon-color;
  border-bottom-right-radius: 80px 40px;
  transform: translate(0, -2px);
}

.phone-controls-message {
  padding: 5px 5px;
  background-color: #ffffff;
  display: flex;
}

.phone-controls-message-photo {
  flex: 1;
  font-size: 35px;
  color: $gray-600;
  padding: 0px 15px 0px 20px;
}

.phone-controls-message-apple-store {
  flex: 1;
  font-size: 35px;
  color: $gray-600;
  padding: 0px 15px;
}

.phone-controls-message-text {
  flex: 10;
  border: 2px solid $gray-500;
  height: 43px;
  margin-right: 18px;
  border-radius: 40px;
  padding: 2px;
}

.phone-controls-message-text-content {
  display: flex;
}

.phone-controls-message-text-content-message {
  flex: auto;
}

.phone-controls-message-text-content-send {
  flex: 1;
  text-align: right;
  color: $success;
}

.phone-footer {
  background-color: #dbdbdb;
  border-bottom-left-radius: $default-radius;
  border-bottom-right-radius: $default-radius;
}

.phone-footer-apps-list {
  display: flex;
  padding: 10px 10px;
}

.phone-footer-apps-list-app {
  height: 50px;
  width: 65px;
  background-color: #c2c5c8;
  margin: 0px 10px;
  border-radius: 30px;
}

.phone-footer-bottom {
  display: flex;
  margin-top: 5px;
  padding-bottom: 10px;
}

.phone-footer-bottom-space {
  flex: 3;
  padding: 0px 40px;
}

.phone-footer-bottom-control {
  flex: 6;
  background-color: black;
  height: 7px;
  border-radius: 20px;
}
</style>
